import { render, staticRenderFns } from "./spd_electoral_roll_fraud.vue?vue&type=template&id=09872216"
import script from "./spd_electoral_roll_fraud.vue?vue&type=script&lang=js"
export * from "./spd_electoral_roll_fraud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports